import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import Modal from "react-modal";
import "leaflet/dist/leaflet.css";
import Drawer from "./Drawer";
import Drawer2 from "./Drawer2";
// Fix for default marker icons in Leaflet
import L, { setOptions } from "leaflet";
import icon from "./images/3.svg";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import { useFetchData } from "../hooks/useFetchData";
import GeoSearchBar from "../../src/ui/Geo";
import Range from "../ui/Range";
import Grid from "@mui/material/Grid";
import Option from "../ui/Option";
import { AreaOptions, FloorOptions, priceOptions } from "../data";
import Cardd from "../ui/Card";
import axios from "axios";
import { grey } from "@mui/material/colors";

import {
  Autocomplete,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";
import { FaSearch } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import NewsBar from "../ui/Newsbar";
import Nav from "../ui/Nav";
import {
  GeoSearchControl,
  OpenStreetMapProvider,
  SearchControl,
} from "leaflet-geosearch";
import customIconUrl from "./images/home.png"; // Replace with your actual image path
import { TestLanguage } from "../hooks/testLanguage";
import AutocompleteOption from "../ui/Autocompleted";
import { Cityauto } from "../ui/Cityauto";
import { Regionauto } from "../ui/Regionauto";

let DefaultIcon = L.icon({
  iconUrl: customIconUrl,
  // shadowUrl: iconShadow,
  iconSize: [30, 30],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  // shadowSize: [41, 41],
});

const MapComponent = () => {
  L.Marker.prototype.options.icon = DefaultIcon;

  // Set app element for accessibility (for react-modal)
  Modal.setAppElement("#root");
  const { t } = useTranslation();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedPoint, setSelectedPoint] = useState(null);
  const [datacard, setDatacard] = useState(null);
  const [offertype, setOffertype] = React.useState(null);
  const [region, setRegion] = React.useState(null);
  const [datasort, setDatasort] = useState();
  const [data2, setData2] = useState();
  const [value, setValue] = useState();
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [regions, setRegions] = useState([]);
  const [status, setStatus] = useState();
  const [filters, setFilters] = useState({
    area_from: null,
    area_to: null,
    price_from: null,
    price_to: null,
    offertype_id: null,
    direction_id: null,
    contract_id: null,
    city_id: null,
    status_id: null,
    region_id: null,
    offertype_category_id: null,
  });
  useEffect(() => {
    try {
      const res = axios.get(
        `${process.env.REACT_APP_API_URL}units?include=status,offertype,direction,contract`
      );
      console.log("hidfgrhty", res.data);
      setData2(res.data);
    } catch (error) {
      console.error("API error:", error);
    }
  }, [data2]);
  useEffect(() => {
    handleApi();
  }, [value]);

  const handleradio = (e) => {
    const newValue = e.target.value;
    setStatus(newValue);
    console.log("status", newValue); // ✅ logs the selected value correctly
  };
  const handlesort = (e) => {
    const selected = e.target.value;
    setValue(selected);
  };
  // try {
  //   const res = await axios.get(`http://3dfinal.tanaghomtech.com/public/api/units?sort=${value}`);
  //   console.log("hi", res.data.data);
  //   setDatasort(res.data.data);
  // } catch (error) {
  //   console.error("API error:", error);
  // }

  const buildApiUrl = (filters) => {
    const {
      area_from,
      area_to,
      price_from,
      price_to,
      offertype_id,
      direction_id,
      status_id,
      city_id,
      region_id,
      offertype_category_id,
    } = filters;
    const params = [];
    const addParam = (key, value) => {
      if (value !== undefined && value !== null && value !== "") {
        params.push(`filter[${key}]=${value}`);
      }
    };

    addParam("status_id", status);
    addParam("city_id", city_id);
    addParam("region_id", region_id);
    addParam("direction_id", direction_id);
    addParam("offertype_id", offertype_id);
    addParam("offertype.category_id", offertype_category_id);

    if (price_from && price_to) {
      addParam("PriceBetween", `${price_from},${price_to}`);
    }

    if (area_from && area_to) {
      addParam("AreaBetween", `${area_from},${area_to}`);
    }
    if (value) {
      params.push(`sort=${value}`);
    }
    const queryString = params.join("&");
    const url = `${process.env.REACT_APP_API_URL}units?filter[post.post_status_id]=4&${queryString}`;

    console.log("Clean URL:", url);
    return url;
  };

  function SearchControl({ setMarkerPosition }) {
    const map = useMap();

    useEffect(() => {
      const provider = new OpenStreetMapProvider();

      const searchControl = new GeoSearchControl({
        provider,
        style: "bar",
        showMarker: false,
        showPopup: false,
        autoClose: true,
        retainZoomLevel: false,
        animateZoom: true,
        keepResult: true,
        searchLabel: "Enter location...",
      });

      map.addControl(searchControl);

      // Listen when user selects a location
      map.on("geosearch/showlocation", (result) => {
        const { x: lng, y: lat } = result.location;
        setMarkerPosition({ lat, lng });
        map.setView([lat, lng], 3);
      });

      return () => map.removeControl(searchControl);
    }, [setMarkerPosition]);

    return null;
  }
  const url = process.env.REACT_APP_API_URL + "points";

  // Sample data for points on the map
  const { data, isLoading, error } = useFetchData(url, "users");

  const openModal = (data) => {
    console.log("data", data);

    setSelectedPoint(data);
    setModalIsOpen(true);
    console.log("data", data);
  };
  const closeModal = () => {
    setModalIsOpen(false);
  };
  const handleOptionChange = (name, selectedItem) => {
    console.log(name);

    if (!selectedItem) return;

    const id =
      selectedItem?.[name]?.id || // if name is 'directions' and selectedItem.directions.id exists
      selectedItem?.id || // fallback: maybe item is directly like { id: 1 }
      null;
    if (
      name === "Price" ||
      name === "area" ||
      name === "Directions" ||
      name === "Type" ||
      name === "Categories" ||
      name === "City" ||
      name === "Region" ||
      name === "Status" ||
      name === "السعر" ||
      name === "المساحة" ||
      name === "الاتجاه" ||
      name === "النوع" ||
      name === "الفئة" ||
      name === "المدينة" ||
      name === "المنطقة" ||
      name === "الحالة"
    ) {
      setFilters((prev) => ({
        ...prev,
        ...((name === "Directions" || name === "الاتجاه") && {
          direction_id: `${id}`,
        }),
        ...((name === "Type" || name === "النوع") && { offertype_id: `${id}` }),
        ...((name === "Status" || name === "الحالة") && { status_id: `${id}` }),
        ...((name === "City" || name === "المدينة") && { city_id: `${id}` }),
        ...((name === "Region" || name === "المنطقة") && {
          region_id: `${id}`,
        }),
        ...((name === "Categories" || name === "الفئة") && {
          offertype_category_id: `${id}`,
        }),
        ...((name === "Price" || name === "السعر") && {
          PriceBetween: `${id},${id}`,
        }),
        ...((name === "area" || name === "المساحة") && {
          AreaBetween: `${id},${id}`,
        }),
      }));
    } else if (name.endsWith("_from") || name.endsWith("_to")) {
      setFilters((prev) => ({
        ...prev,
        ...(name === "price_from" && { [name]: parseFloat(selectedItem) }),
        ...(name === "price_to" && { [name]: parseFloat(selectedItem) }),
        ...(name === "floor_from" && { [name]: parseFloat(selectedItem) }),
        ...(name === "floor_to" && { [name]: parseFloat(selectedItem) }),
        ...(name === "area_from" && { [name]: parseFloat(selectedItem) }),
        ...(name === "area_to" && { [name]: parseFloat(selectedItem) }),
        [name]: parseFloat(selectedItem),
      }));
    }

    console.log("Updated filters:", {
      ...filters,
      ...(name === "price_from" && { [name]: parseFloat(selectedItem) }),
      ...(name === "price_to" && { [name]: parseFloat(selectedItem) }),
      ...(name === "floor_from" && { [name]: parseFloat(selectedItem) }),
      ...(name === "floor_to" && { [name]: parseFloat(selectedItem) }),
      ...(name === "area_from" && { [name]: parseFloat(selectedItem) }),
      ...(name === "area_to" && { [name]: parseFloat(selectedItem) }),
      ...(name === "directions" && { direction_id: id }),
      ...(name === "type" && { offertype_id: id }),
      ...(name === "status" && { contract_id: id }),
    });
  };

  const DrawerComponent = selectedPoint?.type !== "project" ? Drawer2 : Drawer;
  console.log(selectedPoint?.id);

  const handleApi = async () => {
    console.log("hi", filters);
    const url = buildApiUrl(filters);
    try {
      const res = await axios.get(url);
      console.log("hi", res.data.data);
      setDatacard(res.data.data);
    } catch (error) {
      console.error("API error:", error);
    }
  };

  return (
    <Grid
      sx={{
        background: "#d4d4d4",
        background:
          "linear-gradient(0deg, rgba(212, 212, 212, 1) 0%, rgba(255, 255, 255, 1) 100%)",
      }}
      container
      className="map"
    >
      {/* <NewsBar datanews={datanews} openModal={openModal} /> */}
      <Grid
        size={{ xs: 12, md: 4 }}
        sx={{
          height: { xs: "100vh", md: "93vh" },
          overflowY: { xs: "scroll", md: "scroll" },
          overflowX: { xs: "scroll", md: "hidden" },
          zIndex: 500,
        }}
      >
        <Grid
          style={{ margin: "10px" }}
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
          {" "}
          <Grid size={12}>
            <FormControl
              sx={{ fontFamily: "Oswald,Cairo, sans-serif", fontSize: "20px" }}
            >
              <FormLabel
                sx={{ fontFamily: "Oswald,Cairo, sans-serif", color:'#000' , fontSize:'16px' , fontWeight:400}}
                id="demo-radio-buttons-group-label"
              >
                {t("drawerUnit.status")}
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
                onChange={handleradio}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FormControlLabel
                  value="1"
                  control={
                    <Radio
                      sx={{
                        color: grey[800],
                        "&.Mui-checked": {
                          color: grey[600],
                        },
                        "& .MuiSvgIcon-root": {
                          fontSize: 28, // or any size you prefer
                        },
                      }}
                    />
                  }
                  label={t("drawerUnit.forsell")}
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      fontFamily: "Oswald,Cairo, sans-serif",
                      fontSize: "16px",
                      fontWeight: "400",
                    },
                  }}
                />
                <FormControlLabel
                  value="2"
                  control={
                    <Radio
                      sx={{
                        color: grey[800],
                        "&.Mui-checked": {
                          color: grey[600],
                        },
                        "& .MuiSvgIcon-root": {
                          fontSize: 28,
                          // or any size you prefer
                        },
                      }}
                    />
                  }
                  label={t("drawerUnit.forrent")}
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      fontFamily: "Oswald,Cairo, sans-serif",
                      fontSize: "16px",
                      fontWeight: "400",
                    },
                  }}
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid size={6}>
            <Option
              name={t("drawerUnit.categories")}
              url="categories"
              offertype={offertype}
              setOffertype={setOffertype}
              onSelect={handleOptionChange}
            />
          </Grid>
          <Grid size={6}>
            <Option
              name={t("drawerUnit.type")}
              offertype={offertype}
              onSelect={handleOptionChange}
            />
          </Grid>
        </Grid>
        <Grid
          style={{ margin: "10px" }}
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
          <Grid size={4}>
            <Range
              name={t("drawerUnit.price")}
              label={t("drawerUnit.price")}
              array={priceOptions}
              onSelect={handleOptionChange}
            />
          </Grid>
          <Grid size={4}>
            <Range
              name={t("drawerUnit.area")}
              label={t("drawerUnit.area")}
              array={AreaOptions}
              onSelect={handleOptionChange}
            />
          </Grid>
          <Grid size={4}>
            <Option
              name={t("drawerUnit.directions")}
              url="directions"
              onSelect={handleOptionChange}
            />
          </Grid>

          <Grid size={6}>
            <Cityauto
              selectedCity={selectedCity}
              setSelectedCity={setSelectedCity}
              setRegions={setRegions} // ✅ make sure this is passed
              onSelect={handleOptionChange}
            />
          </Grid>
          <Grid size={6}>
            <Regionauto
              regions={regions}
              selectedRegion={selectedRegion}
              setSelectedRegion={setSelectedRegion}
              onSelect={handleOptionChange}
            />
          </Grid>
        </Grid>
        <Grid
          style={{ margin: "10px" }}
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
          <Grid size={12}>
            <Button
              variant="contained"
              onClick={handleApi}
              style={{
                fontWeight: "300",
                fontFamily: "Oswald,Cairo, sans-serif",
                fontSize: "15px",
                padding: "0px 239px",
                borderRadius: "4px",
                width: "100%",
                padding: "5px 0px",
                fontFamily: "Oswald,Cairo, sans-serif",
                margin: "10px 0px",
                marginRight: "20px",
                backgroundColor: "#232324",
                color: "#fff",
              }}
            >
              {t('drawerUnit.searchbutton')}
              {/* <FaSearch size={18} /> */}
            </Button>
          </Grid>
        </Grid>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "space-between",
            margin: "10px",
            alignItems: "center",
          }}
        >
          <h5
            style={{
              fontFamily: "Oswald,Cairo, sans-serif",
              fontWeight: "300",
            }}
          >
            <b>714</b> from <b>205</b> results
          </h5>
          <FormControl sx={{ m: 1, minWidth: 120, padding: "0px" }}>
            <InputLabel
              id="demo-simple-select-helper-label"
              sx={{ fontFamily: "Oswald,Cairo, sans-serif" }}
            >
              sort by
            </InputLabel>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              label="Age"
              sx={{ height: "40px", fontFamily: "Oswald,Cairo, sans-serif" }}
              onChange={handlesort}
            >
              <MenuItem value=""></MenuItem>
              <MenuItem
                sx={{
                  fontFamily: "Oswald,Cairo, sans-serif",
                  fontWeight: "300",
                }}
                value="-price"
              >
                price high to low
              </MenuItem>
              <MenuItem
                sx={{
                  fontFamily: "Oswald,Cairo, sans-serif",
                  fontWeight: "300",
                }}
                value="price"
              >
                price low to high
              </MenuItem>
              <MenuItem
                sx={{
                  fontFamily: "Oswald,Cairo, sans-serif",
                  fontWeight: "300",
                }}
                value="-total_area"
              >
                area high to low
              </MenuItem>
              <MenuItem
                sx={{
                  fontFamily: "Oswald,Cairo, sans-serif",
                  fontWeight: "300",
                }}
                value="total_area"
              >
                area low to high
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid
          style={{ margin: "10px" }}
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
          {(() => {
            if (Array.isArray(datasort) && datasort?.length > 0) {
              return datasort.map((i, index) => (
                <Grid key={i.id || index} size={6} onClick={() => openModal(i)}>
                  <Cardd data={i} />
                </Grid>
              ));
            }

            if (Array.isArray(datacard) && datacard?.length > 0) {
              return datacard.map((i, index) => (
                <Grid key={i.id || index} size={6} onClick={() => openModal(i)}>
                  <Cardd data={i} />
                </Grid>
              ));
            }

            return <p>No data available</p>;
          })()}
        </Grid>
      </Grid>
      <Grid
        sx={{
          overflowY: { xs: "scroll", md: "hidden" },
          display: { xs: "none", md: "block" },
        }}
        size={{ xs: 12, md: 8 }}
      >
        <MapContainer
          center={[33.5, 36.28]}
          zoom={7}
          style={{ width: "100%", height: "100%", overflowY: "hidden" }}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />
          {data?.data?.map((point) => (
            <Marker
              key={point.id}
              style={{ color: "red" }}
              position={[
                parseFloat(point.latitude),
                parseFloat(point.longitude),
              ]}
              eventHandlers={{
                mouseover: (e) => e.target.openPopup(),
                mouseout: (e) => e.target.closePopup(),
                click: () => openModal(point),
              }}
            >
              <Popup>
                <div className="popup-container">
                  <img
                    src={`http://3dfinal.tanaghomtech.com/storage/app/public/${point.image}`}
                    alt=""
                    className="popup-image"
                    // style={{
                    //   width: "130px",
                    //   height: "100px",
                    //   borderRadius: "8px",
                    //   cursor: "pointer",
                    //   // padding: "0",
                    // }}
                    // onClick={() => {
                    //   openModal(point);
                    // }}
                  />
                  <br />
                  <p
                    className="popup-text"
                    // style={{
                    //   textAlign: "center",
                    //   margin: "5px 0",
                    //   fontFamily: "Oswald,Cairo, sans-serif",
                    //   fontSize: "12px",
                    // }}
                  >
                    {TestLanguage(point, "name")}
                  </p>
                </div>
              </Popup>
            </Marker>
          ))}
          <GeoSearchBar setMarkerPosition={setOptions} />
        </MapContainer>
      </Grid>{" "}
      {selectedPoint && (
        <DrawerComponent
          point={selectedPoint?.id}
          isOpen={modalIsOpen}
          onClose={closeModal}
        >
          {/* <h2>{selectedPoint?.name}</h2>
                   <p>{selectedPoint?.description}</p> */}
          <h2>{TestLanguage(selectedPoint?.offertype, "name")}</h2>
          <h2>{TestLanguage(selectedPoint, "name")}</h2>
          <p>{TestLanguage(selectedPoint, "description")}</p>
        </DrawerComponent>
      )}
    </Grid>
  );
};

export default MapComponent;
